import React from 'react';
import { Divider } from 'semantic-ui-react'

const VerTar1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel, handleClickSel1}) => {
  const a251005 = autorizacUA.findIndex( autorizac => autorizac === "251005" );
  const a251010 = autorizacUA.findIndex( autorizac => autorizac === "251010" );
  const a251015 = autorizacUA.findIndex( autorizac => autorizac === "251015" );
  const a251020 = autorizacUA.findIndex( autorizac => autorizac === "251020" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a251005!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a251010!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }

      {(a251005!==-1||a251010!==-1) &&
      <Divider inverted />
      }

      {(a251015!==-1||a251020!==-1) &&
      <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
        <i className="large settings yellow icon"></i>
        Configurar
      </button>
      }
      {a251015!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large newspaper outline violet icon"></i>
        Servicios
      </button>
      }

      {(a251015!==-1||a251020!==-1) &&
      <Divider inverted />
      }

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerTar1
